import { useFetch } from '@/shared/hooks/useFetch';
import { queryKeys } from '@/shared/api/queryKeys';
import { apiRoleGet } from '@/entities/roles/modules/api/roles';

export const useRole = (id: string | null | undefined) =>
  useFetch({
    api: () => apiRoleGet(id as string),
    keywords: queryKeys.roles.detail(id ?? ''),
    enabled: Boolean(id),
    staleTime: 30_000,
  });
